import { mainUrl, client } from '../app-constants';

export function validateUser(loginId, password) {
    const url = mainUrl + 'pt.login/validateUser'

    return client.post(url, { loginId, password });
}

